/**
 * @author Fernando Ruano
 * @file index.js
 * @description Form Item Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'antd';

/**
 * Form Item Component
 * @param { Object } props - React PropTypes
 * @property { Any } name - Name value param.
 * @property { Object } item - item children.
 * @property { String } label - FormItem Label.
 * @property { Array } rules - FormItem Rules.
 * @property { Object } breakpoints - FormItem Responsive Breakpoints.
 */
const FormItem = ({
  item,
  name,
  label,
  rules,
  breakpoints,
  normalize,
  tooltip
}) => (
  <Col {...breakpoints}>
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      normalize={normalize}
      tooltip={tooltip}>
      {item}
    </Form.Item>
  </Col>
);

/**
 * @name FormItem.propTypes
 * @type { propTypes }
 * @property { Any } name - Name value param.
 * @property { Object } item - item children.
 * @property { String } label - FormItem Label.
 * @property { Array } rules - FormItem Rules.
 * @property { Object } breakpoints - FormItem Responsive Breakpoints.
 */
FormItem.propTypes = {
  name: PropTypes.any,
  item: PropTypes.object,
  label: PropTypes.string,
  rules: PropTypes.array,
  breakpoints: PropTypes.object,
  normalize: PropTypes.any,
  tooltip: PropTypes.any
};

/**
 * Default properties.
 */
FormItem.defaultProps = {
  label: '',
  rules: [{ required: false }],
  breakpoints: { xs: 24, sm: 12, md: 8, lg: 6 }
};

export default FormItem;
